import { render, staticRenderFns } from "./FornecedorPorCotar.vue?vue&type=template&id=144a8ee8&scoped=true"
import script from "./FornecedorPorCotar.vue?vue&type=script&lang=js"
export * from "./FornecedorPorCotar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144a8ee8",
  null
  
)

export default component.exports